import React from 'react'
import { useTranslation } from 'react-i18next'
import ResponsiveBreakpointsRolloutBoundary from 'components/ResponsiveBreakpointsRolloutBoundary'
import { RESPONSIVE_BREAKPOINT_PAGES } from 'constants/responsiveBreakpoints'
import { AccountContent } from './AccountContent'
import { AccountContainer } from './Account.styles'

export const AccountWithRollout = () => {
  const { t } = useTranslation()

  return (
    <ResponsiveBreakpointsRolloutBoundary
      fallback={
        <AccountContainer $responsiveBreakpointsV2={false}>
          <div aria-live="polite" role="status">
            {t('general.loading')}
          </div>
        </AccountContainer>
      }
      page={RESPONSIVE_BREAKPOINT_PAGES.ACCOUNT}
    >
      <AccountContent />
    </ResponsiveBreakpointsRolloutBoundary>
  )
}

export default AccountWithRollout
